import { FC, useEffect, useRef, useState } from 'react'
import lottie, { AnimationItem } from 'lottie-web'

export interface LottieAnimationProps {
  className?: string
  play: boolean
  path: string
  loop: boolean
}

export const LottieAnimation: FC<LottieAnimationProps> = ({
  className,
  play,
  path,
  loop = false,
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const animationRef = useRef<AnimationItem | null>(null)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const containerEl = containerRef.current

    if (containerEl) {
      // defer loading the animation to ensure container is initialised
      const timeoutId = setTimeout(() => {
        animationRef.current = lottie.loadAnimation({
          container: containerEl,
          autoplay: false,
          loop: loop,
          path,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
          },
        })
        setReady(true)
      }, 0)

      return () => {
        clearTimeout(timeoutId)
        if (animationRef.current) {
          animationRef.current.destroy()
          animationRef.current = null
        }
      }
    }
  }, [loop, path])

  useEffect(() => {
    if (animationRef.current) {
      if (play) {
        animationRef.current.play()
      } else {
        animationRef.current.stop()
      }
    }
  }, [play, ready])

  return <div className={className} ref={containerRef} />
}
